import { getFormValues } from "redux-form";

import type { ReduxFormLinks } from "~/components/patient/addLinks";
import type { TAlignersFormValues } from "~/components/patient/patient_new/patient_new_additional_aligners";
import type { RootState } from "~/store";
import type { TPrescriptionReduxForm } from "~/types/redux-form";

export const selectCorrectionFormValues = (state: RootState) =>
  getFormValues("correction")(state) as TPrescriptionReduxForm | undefined;

export const selectAdditionalAlignersFormValues = (state: RootState) =>
  getFormValues("additional_aligners")(state) as TAlignersFormValues | undefined;

export const selectLinksFormValues = (state: RootState) =>
  getFormValues("links")(state) as ReduxFormLinks | undefined;
